module.exports = __webpack_public_path__ + "static/media/img-default.b957d176.png";